module.exports = __webpack_public_path__ + "img/2.793c7ca8.jpg";